import { defineMessages } from 'react-intl'


export default defineMessages({
  cookiePreferences: {
    defaultMessage: 'Cookie Preferences',
    id: 'floating-preferences-button.cookie-preferences',
  },
  documentation: {
    defaultMessage: 'See {url} to learn how to reveal and customize this floating cookie preferences button',
    id: 'floating-preferences-button.documentation',
  },
})
